import Session from './session'

export default class UserAPI {

  static get PREFIX () {
    return Session.HOST + '/api/user'
  }

  /**
  * ユーザ一覧取得
  */
  static getUserList (params) {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/list', {params: params})
  }

  /**
  * ユーザ取得
  */
  static getUser (id) {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/get/' + id)
  }

  /**
  * ユーザ情報取得
  */
  static getUserInfo (params) {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/info', {params: params})
  }

  /**
   * ユーザ更新
   */
  static editUser (data) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/update', data)
  }

  /**
   * ユーザ勤務登録更新
   */
  static editUserWorkRegistration (data) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/work-registration/update', data)
  }

  // ユーザ設定更新
  static updateSetting (data) {
    const s = new Session()
    return s.ins.patch(this.PREFIX + '/update-setting', data)
  }

  /**
   * ユーザ登録
   */
  static createUser (data) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/create', data)
  }

  /**
   * ユーザ勤務登録
   */
  static createUserWorkRegistration (data) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/work-registration/create', data)
  }

  /**
   * ユーザ勤務登録取得
   */
  static getUserWorkRegistration (id) {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/work-registration/' + id)
  }

  /**
   * ユーザ勤務登録削除
   */
  static deleteUserWorkRegistration (id) {
    const s = new Session()
    return s.ins.delete(this.PREFIX + '/work-registration/delete/' + id)
  }

  /**
   * 退職
   */
  static retireeUser (id, date) {
    const s = new Session()
    return s.ins.delete(this.PREFIX + '/retiree/' + id + '/' + date)
  }

  /**
   * 削除
   */
  static deleteUser (id) {
    const s = new Session()
    return s.ins.delete(this.PREFIX + '/delete/' + id)
  }

  /**
  * 既存チェック
  */
  static isExists (data) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/is-exists', data)
  }

  /**
   * 添付削除
   */
  static deleteFile (userId) {
    const s = new Session()
    return s.ins.delete(this.PREFIX + '/upload/' + userId)
  }

  /**
   * アップロード
   */
  static upload (userId, data) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/upload/' + userId, data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  }

  /**
   * 定期券削除
   */
  static deleteUserWorkRegistrationFile (userId, registrationId) {
    const s = new Session()
    return s.ins.delete(this.PREFIX + '/work-registration/upload/' + userId + '/' + registrationId)
  }

  /**
   * 定期券アップロード
   */
  static uploadUserWorkRegistration (userId, registrationId, data) {
    const s = new Session()
    return s.ins.post(this.PREFIX + '/work-registration/upload/' + userId + '/' + registrationId, data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  }

  /**
   * 定期券ダウンロード
   */
  static downloadUserWorkRegistration (userId, registrationId) {
    const s = new Session()
    return s.ins.get(this.PREFIX + '/work-registration/download/' + userId + '/' + registrationId)
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/api/user-api.js